import React from 'react';

import { Button, buttonClasses } from '@mui/material';

import type { SxProp } from 'src/types/mui';

import type { TableActionButtonProps } from './types';

export const TableActionButton: React.FC<TableActionButtonProps> = ({
  children,
  icon,
  ...props
}) => {
  return (
    <Button
      sx={actionButtonStyles}
      variant="outlined"
      size="medium"
      color="secondary"
      startIcon={icon}
      {...props}
    >
      {children}
    </Button>
  );
};

const actionButtonStyles: SxProp = {
  border: 0,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  '&:hover': {
    border: 0,
  },
  [`&.${buttonClasses.disabled}`]: {
    border: 0,
  },
};
